export default __webpack_public_path__ + "4536fd0738f36c3463bccee34510b7ec.svg";